import { CriteriaType, MAX_COUNT_PINNED_FILTERS, MAX_COUNT_UNPINNED_FILTERS } from '@constants'
import { GETSearchType, SortDirection } from '@types'

import { SearchAssistantController } from '../controller/search-assistant.controller'
import { Sort } from '../lib/constants'
import { SearchAssistantRepository } from '../repository/search-assistant.repository'

export class SearchAssistantPresenter {
  private controller: SearchAssistantController

  constructor(private searchAssistantKey: string | undefined) {
    const repository = new SearchAssistantRepository(this.searchAssistantKey)
    this.controller = new SearchAssistantController(repository)
  }

  public saveDefaultSearchFilter(defaultSearchFilter: GETSearchType | null) {
    this.controller.saveDefaultSearchFilter(defaultSearchFilter)
  }

  public saveSelectedFavouriteCriteria(selectedFavouriteCriteria: GETSearchType | null) {
    this.controller.saveSelectedFavouriteCriteria(selectedFavouriteCriteria)
  }

  public saveCriterias(criterias: CriteriaType[]) {
    this.controller.saveCriterias(criterias)
  }
  public closeFilterManager(dialogId: string) {
    this.controller.closeFilterManager(dialogId)
  }

  public disposeSearchAssistant() {
    this.controller.disposeSearchAssistant()
  }

  public getUnpinnedCriteriaFields(criterias: CriteriaType[]) {
    return criterias.filter(criteria => !criteria.isPinning)
  }

  public getVisiblePinnedCriteriaFields(visibleCriterias: CriteriaType[]) {
    return visibleCriterias
      .filter(criteria => criteria.isPinning)
      .slice(0, MAX_COUNT_PINNED_FILTERS)
      .sort((a, b) => a.title.localeCompare(b.title))
  }

  public getVisibleUnpinnedCriteriaFields(visibleCriterias: CriteriaType[]) {
    return visibleCriterias
      .filter(criteria => !criteria.isPinning)
      .slice(0, MAX_COUNT_UNPINNED_FILTERS)
  }

  private getSortedSearchFiltersByTitle(searchFilters: GETSearchType[], direction: SortDirection) {
    const _searchFilters = structuredClone(searchFilters)

    _searchFilters.sort((a, b) => {
      const titleA = a.title.toLowerCase()
      const titleB = b.title.toLowerCase()

      if (direction === Sort.Desc) {
        return titleA > titleB ? -1 : 1
      }

      return titleA < titleB ? -1 : 1
    })

    return _searchFilters
  }

  public getOrderedSearchFilters(savedSearchFilters: GETSearchType[], sort: SortDirection | false) {
    let sortedSearchFiltersByTitle = savedSearchFilters

    if (sort === Sort.Asc) {
      sortedSearchFiltersByTitle = this.getSortedSearchFiltersByTitle(
        sortedSearchFiltersByTitle,
        Sort.Desc
      )
    }
    if (sort === Sort.Desc) {
      sortedSearchFiltersByTitle = savedSearchFilters
    }

    if (!sort) {
      sortedSearchFiltersByTitle = this.getSortedSearchFiltersByTitle(
        sortedSearchFiltersByTitle,
        Sort.Asc
      )
    }

    return sortedSearchFiltersByTitle
  }
}
